import React from "react";
import { Link } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import HeaderLeft from "./HeaderLeft";

function AccountSettings(props) {
  let user = localStorage.getItem("user");
  user = JSON.parse(user);

  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Account Settings</h1>
          {/*  <p class="mb_40 them_para text-center mx-auto text_limit">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim{" "}
          </p> */}
          <div class="list_detail">
            <ul>
              <li>
                {" "}
                Total Video Count<span>{user.data.work_limit} Videos</span>{" "}
              </li>
              <li>
                {" "}
                Current Status
                <span>
                  {user.data.is_available === 1 ? "Available" : "Unavailable"}
                </span>{" "}
              </li>
            </ul>
          </div>
          <div class="btn_wraper">
            <Link to="/editSettings">
              <button type="button" class="them_btn mt_40 mb_30">
                Edit Settings
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default AccountSettings;
